import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { watchInstallPrompt } from "./lib/install";
import { applyTheme, loadPreferences } from "./lib/preferences";
import "./styles.css";

// Before the first paint, so a forced light theme never flashes dark first.
applyTheme(loadPreferences().theme);
// `beforeinstallprompt` fires early and only once; catching it later is too late.
watchInstallPrompt();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root-Element fehlt.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
